// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__w5T46","main-menu":"NavBar_main-menu__BpaeQ","display":"NavBar_display__DaJlH","menuItem":"NavBar_menuItem__uF+C1"};